module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-red.12355f14.png";